import { ContentContainer, ProductType, type Config, type Options } from "../core/types";
import type { CalculatorData, CalculatorQueryParams } from "./types";

export interface IIframeProvider {
    createIframe(widgetKey: string, config: Config, options: Options, contentContainer: ContentContainer, isSwapFromForm?: boolean, calculatorData?: CalculatorData): HTMLIFrameElement;
}

// Default implementation - creates iframes for WordPress environment
// In the future, you might have: ApiIframeProvider, LocalIframeProvider, etc.
export class IframeProvider implements IIframeProvider {
    private dataSource = 'selectfi_widget';
    constructor(
        private trackerId: string,
        private environment?: string
    ){}

    createIframe(widgetKey: string, config: Config, options: Options, contentContainer: ContentContainer, isSwapFromForm: boolean = false, calculatorData?: CalculatorData): HTMLIFrameElement {
        let url;
        
        if (isSwapFromForm) {
            this.dataSource = 'selectfi_calculator_widget';
        }
        if (contentContainer.productType === ProductType.CALCULATOR) {
            // Prod serves the calculator as a route on the main app, so dev points at the main app
            // too (BP_PUBLIC_APP_PORT, default 8001) rather than the standalone bundle's old port.
            const base = this.environment === 'development' ? 'http://localhost:8001/payment-calculator' : 'https://app.selectfi.com/payment-calculator';
            const queryString: CalculatorQueryParams = {
                tracker_id: this.trackerId,
                sales_tax_rate: config.salesTaxRate,
                vehicle_price: contentContainer.vehiclePrice!,
                vehicle_year: contentContainer.vehicleYear!,
                vehicle_make: contentContainer.vehicleMake!,
                vehicle_model: contentContainer.vehicleModel!,
                primary_color: config.styles.calculator.primaryColor.replace("#", ""), // Remove '#' for URL
                copy_text: config.copy.calculator.continueButtonText,
            };
            const queryParams = new URLSearchParams(queryString as unknown as Record<string, string>);
            url = `${base}/?${queryParams.toString()}`;
        } else if (contentContainer.productType === ProductType.SCREENING) {
            const base = this.environment === 'development' ? 'http://localhost:8080' : 'https://selectfi.app';
            url = `${base}/dealership-integration/?dealer_id=${widgetKey}&data-source=${this.dataSource}&tracker_id=${this.trackerId}`;
        } else if (contentContainer.productType === ProductType.FULL) {
            const base = this.environment === 'development' ? 'http://localhost:8080' : 'https://selectfi.app';
            url = `${base}/dealership-integration/?dealer_id=${widgetKey}&data-source=${this.dataSource}&full_app=true&tracker_id=${this.trackerId}`;
        }

        if (contentContainer.productType === ProductType.SCREENING || contentContainer.productType === ProductType.FULL) {
            if (contentContainer.vin) {
                url += `&vin=${encodeURIComponent(contentContainer.vin)}`;
            }
            if (options.testMode === true) {
                url += `&test_mode=true`;
            }
            // TTP-574: forward the calculator snapshot so WordPress can persist it to the quote.
            // encodeURIComponent because raw JSON is not valid in a query string.
            if (calculatorData) {
                url += `&calculator_data=${encodeURIComponent(JSON.stringify(calculatorData))}`;
            }
        }

        const iframe = document.createElement('iframe');
        iframe.src = url!;
        iframe.style.border = 'none';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        
        return iframe;
    }
}